import React, { useState, useEffect } from "react";
import styled from "styled-components";

// ⬇️ styled-components (pozostawiam Twoje definicje)
const GalleryMainbox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  background-color: rgb(248, 248, 248);
  min-height: 100px;
  border-radius: 25px;
  width: 80%;
  margin: auto;
  padding: 30px;
  gap: 10px;
  margin-top: 20px;
  
  @media screen and (max-width: 800px) {
    justify-content: center;
  }
`;

const ZdjWrapper = styled.div`
  position: relative;
  width: 240px;
  height: 180px;
  &:hover img {
    transform: scale(0.98);
    filter: brightness(80%);
    border-radius: 4px;
  }
  &:hover div {
    opacity: 1;
  }
`;

const Zdj = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 2px;
  transition: 0.3s ease-in-out;
`;

const CommentOverlay = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
`;

const PhotoProfileOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-y: auto;
  padding: 40px 0;
  z-index: 999;
  
`;

const PhotoProfile = styled.div`
  position: relative;
  width: 70vw;
  background-color: white;
  min-height: 400px;
  border-radius: 25px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 20px;
  @media screen and (max-width: 800px){
    width: 100vw;
  }
`;

const PhotoNavBar = styled.div`
  height: 30px;
  width: 100%;
  background-color: white;
`;

const CommentsBar = styled.div`
  width: 70%;
  margin: 10px auto;
  min-height: 100px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  @media screen and (max-width: 800px){
    width: 100%;
  }
`;

const CommentInputBox = styled.div`
  width: 90%;
  min-height: 70px;
  background-color: #f6f6f6;
  margin: auto;
  border-radius: 20px;
  border: 1px solid lightgray;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  textarea {
    background-color: #f6f6f6;
    box-sizing: border-box;
    width: 100%;
    border: none;
    outline: none;
    resize: none;
    padding: 10px;
    font-size: 16px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    font-family: inherit;
  }
  .commentButton{
    background-color: #234ffc;
    color: white;
    padding: 3px 5px;
    border-radius: 9999px;
    font-size: 14px;
    margin: 10px;
    cursor: pointer;
    transition: 0.3s ease-in-out;
  }
  .commentButton:hover{
    background-color: #123eeb;
  }
`;

const CommentBox = styled.div`
  width: 90%;
  min-height: 80px;
  background-color: #f9f9f9;
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  gap: 30px;
  padding: 20px 10px;

  .commentBoxImg {
    height: 80px;
    width: 80px;
    background-color: #f0f0f0;
    border-radius: 99999px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .commentBoxContent{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .commentBoxUsername{
      width: fit-content;
      font-weight: 400;
      color: #505050;
      font-size: 22px;
    }
    .commentBoxText{
      min-height: 60px;
      width: 90%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      font-weight: 300;
      font-size: 18px;
      color: #707070;
      
    }
  }
`;

export default function Gallery() {
  const [photos, setPhotos] = useState(() => {
    const saved = localStorage.getItem("gallery");
    return saved ? JSON.parse(saved) : [];
  });
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [comment, setComment] = useState("");

  // ✅ Pobranie zdjęć z API i zapis w localStorage
  const fetchPhotos = async () => {
    try {
      const res = await fetch("https://api.pth-hokej.pl/api/gallery");
      const data = await res.json();
      setPhotos(data);
      localStorage.setItem("gallery", JSON.stringify(data));
    } catch (err) {
      console.error("❌ Błąd pobierania zdjęć:", err);
    }
  };

  useEffect(() => {
    fetchPhotos();
  }, []);

  // Obsługa dodawania komentarza
  const handleAddComment = async () => {
    if (!comment.trim() || !selectedPhoto?._id) return;
    try {
      await fetch(`https://api.pth-hokej.pl/api/gallery/${selectedPhoto._id}/comment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userName: "Gość", comText: comment }),
      });
      setComment("");
      await fetchPhotos(); // odśwież zdjęcia i zapis w localStorage

      // odśwież wybrany obiekt
      const updated = photos.find((p) => p._id === selectedPhoto._id);
      if (updated) setSelectedPhoto(updated);
    } catch (err) {
      console.error("❌ Błąd dodawania komentarza:", err);
    }
  };

  // Synchronizacja wybranego zdjęcia z listą po aktualizacji danych
  useEffect(() => {
    if (selectedPhoto) {
      const fresh = photos.find((p) => p._id === selectedPhoto._id);
      if (fresh) setSelectedPhoto(fresh);
    }
  }, [photos]);

  return (
    <>
      <GalleryMainbox>
        <div className="gallerySectionTitle">Galeria zdjęć</div>
        {Array.isArray(photos) && photos.map((zdj) => (
          <ZdjWrapper key={zdj._id} onClick={() => setSelectedPhoto(zdj)}>
            <Zdj src={zdj.link} />
            <CommentOverlay>
              <img src="./icons/comment.svg" alt="comments" width="16" height="16" />
              {zdj.coms?.length || 0}
            </CommentOverlay>
          </ZdjWrapper>
        ))}
      </GalleryMainbox>

      {selectedPhoto && (
        <PhotoProfileOverlay onClick={() => setSelectedPhoto(null)}>
          <PhotoProfile onClick={(e) => e.stopPropagation()}>
            <img src={selectedPhoto?.link} style={{ width: "100%" }} alt="big" />
            <CommentsBar>
              <div className="commentsSectionTitle">Komentarze</div>
              {selectedPhoto.coms?.map((com, idx) => (
                <CommentBox key={idx}>
                  <div className="commentBoxImg">
                    <img src="./icons/user.svg" height="70%" width="70%" alt="user" />
                  </div>
                  <div className="commentBoxContent">
                    <div className="commentBoxUsername">{com.userName}</div>
                    <div className="commentBoxText">{com.comText}</div>
                  </div>
                </CommentBox>
              ))}
              <CommentInputBox>
                <textarea
                  placeholder="Skomentuj jako gość"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
                <div className="commentButton" onClick={handleAddComment}>
                  Skomentuj
                </div>
              </CommentInputBox>
            </CommentsBar>
            <PhotoNavBar/>
          </PhotoProfile>
          
        </PhotoProfileOverlay>
      )}
    </>
  );
}